// extracted by mini-css-extract-plugin
export default {"main":"index_main_-R-Js","aside":"index_aside_kIxf-"};